import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@qodo/design-system';
import { Building2 } from 'lucide-react';
import { cn } from 'utils/className';
import { spawn } from 'utils/translations';
import { OrgRowProps } from '../types';
import { groupReposByProject } from '../utils';
import { ProjectRow } from './ProjectRow';
import { SelectionCheckboxRow } from './SelectionCheckboxRow';

export const OrgRow = ({
  org,
  selectedIds,
  orgsLength,
  onToggleOrganization,
  onToggleProjectRepos,
  onToggleRepository,
}: OrgRowProps) => {
  const spawnStep = spawn('dialogs.azure-installation.steps.connect-repos');
  const orgReposLength = org.repositories.length;
  const allOrgReposUsed =
    orgReposLength > 0 && org.repositories.every((r) => r.isUsed);
  const orgSelectableRepoIds = org.repositories
    .filter((r) => !r.isUsed)
    .map((r) => r.id);
  const allOrgSelected =
    orgSelectableRepoIds.length > 0 &&
    orgSelectableRepoIds.every((id) => selectedIds.has(id));
  const projects = groupReposByProject(org.repositories);
  const projectLength = projects.length;

  const renderProjects = () => {
    if (projectLength === 0) {
      return (
        <div className="flex items-center gap-2 py-1.5 px-3">
          <span className="text-sm text-neutral-500">
            {spawnStep('no-repos')}
          </span>
        </div>
      );
    }

    return projects.map((project) => (
      <ProjectRow
        key={project.projectId}
        project={project}
        selectedIds={selectedIds}
        onToggleProjectRepos={onToggleProjectRepos}
        onToggleRepository={onToggleRepository}
      />
    ));
  };

  const accordionClassName = cn('px-3', {
    'mb-6': orgsLength > 1,
    'mb-0': orgsLength === 1,
  });

  return (
    <AccordionItem value={org.name} className={accordionClassName}>
      <AccordionTrigger className="flex-1 text-sm font-medium py-2">
        <div className="flex gap-3" onClick={(e) => e.stopPropagation()}>
          <SelectionCheckboxRow
            name={`azure-org-${org.name}`}
            checked={allOrgSelected}
            onCheckedChange={() => onToggleOrganization(orgSelectableRepoIds)}
            ariaLabel={org.name}
            label={org.name}
            icon={Building2}
            disabled={allOrgReposUsed}
          />
        </div>
      </AccordionTrigger>

      <AccordionContent className=" space-y-1 border border-border-interactive-neutral-idle rounded-sm mb-2">
        <div
          className="space-y-1 min-h-16 max-h-88 overflow-auto"
          onClick={(e) => e.stopPropagation()}
        >
          {renderProjects()}
        </div>
      </AccordionContent>
    </AccordionItem>
  );
};
